import React from 'react';
import './searchDropdown.scss';
import { connect } from 'react-redux';
import Account from '../../UIElements/account';

const SearchDropdown = ({ searchResult }) => {

  return ( 
    <div className='search-dropdown'>
      <div className='search-items'> 
        <Account accounts={searchResult} />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  searchResult: state.search.searchResult
})


export default connect(mapStateToProps)(SearchDropdown);